import "./RichText.css";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import { getRootUrl } from "../../consts";
import { getErrMsgs, useTblInfo, regUses, randomUUID, getTblDef } from "../../axios_with_token";

const rootUrl = getRootUrl();
// [todo] 1) change getTblDef to useTblDefs

// https://github.com/hugerte/hugerte-docs
// import hugerte from "hugerte";
// import { Editor } from "hugerte";

// https://github.com/zxiaosi/blog-code/blob/react-tinymce-default/src/components/CustomEditor/index.tsx
// import { Editor } from "@tinymce/tinymce-react";

// react tinymce, extension
// https://github.com/zxiaosi/blog-code/blob/react-tinymce-default/src/components/CustomEditor/index.tsx#L151C11-L183C42
// bootstrap integration
// https://www.tiny.cloud/docs/tinymce/5/bootstrap/

function addBr(editor){
    const startNode = editor.selection.getStart();
    if (startNode) {
        const parentNode = startNode.parentNode;
        const newNode = editor.dom.create('br', {
            contenteditable: 'true',
        }, ``);
        // [] insert new node
        const parentParent = parentNode.parentNode;
        parentParent.insertBefore(newNode, parentNode.nextSibling);
    }

    editor.fire('change');
}

function clearContainer(editor){
    const startNode = editor.selection.getStart();
    if (startNode) {
        const parentNode = startNode.parentNode;
        parentNode.innerHTML = '';
    }

    editor.fire('change');
}

function deleteFldAtCursorWithTag(editor){
        // console.log('on del fld', dialogApi, details);
    // editor.selection.select(editor.selection.getNode());
    // editor.dom.remove(editor.selection.getNode());
    // editor.dom.remove(editor.dom.select(`[data-fldname]`));
    const range = editor.selection.getRng();
    // const startContainer = range.startContainer;
    const startOffset = range.startOffset; // Position within the node

    // get current node
    const node = editor.selection.getNode();

    // get target node
    const selector = `[data-fldname]`;
    const tgtNode = editor.dom.is(node, selector)?node:editor.dom.getParent(node, selector);
    
    // Find the previous sibling node
    const previousNode = tgtNode.previousSibling;

    // remove
    editor.dom.remove(tgtNode);
    // editor.notificationManager.open({
    //     text: 'You clicked the custom button!',
    //     type: 'info'
    // });
    if (previousNode) {
        editor.selection.setCursorLocation(previousNode, 0);
    }else{
        // editor.ui.hideContextToolbar();
        // Hide the context toolbar by changing the selection
        const body = editor.getBody();
        editor.selection.setCursorLocation(body, 0); // Move cursor to the start of the editor
    }

    editor.fire('change');

}

function deleteFldAtCursor(editor){
    const startNode = editor.selection.getStart();
    if (startNode) {
        const parentNode = startNode.parentNode;
        parentNode.removeAttribute("data-fldname");
    }

    editor.fire('change');
}
// window.tinymce.PluginManager.add('mycustomplugin', function (editor, url) {
//     // Add a button to the toolbar
//     editor.ui.registry.addButton('mycustombutton', {
//       text: 'My Plugin',
//       onAction: function () {
//         // Open the settings dialog when the button is clicked
//         openAddFldSettingsDialog(editor);
//       }
//     });
// });

// https://github.com/tinymce/tinymce/issues/3592
export default function RichText({fldName, form, fldDef, opts}){
    opts = opts || {};
    const {...rest} = form.register(fldName, {required: 1});

    const refData = useRef({
        editorId: `editorid-${randomUUID()}`,
        taId: `taid-${randomUUID()}`,
        tblInfo: null
    });

    // const textarea = useRef();
    const [editor, setEditor] = useState(false);
    const refEditorData = useRef({});

    const {regUse, isLoading, hasError, getErrorMsgs} = regUses();

    const {data:tblInfo} = regUse(useTblInfo());

    // Function to open the settings dialog
    const openAddFldSettingsDialog = editor=>{
        const getFieldsOptions = _=>{
            const options=(editor.refEditorData.current.fldList||['no field']).map(tblName=>{
                return {
                    text: tblName,
                    value: tblName
                };
            });
            return options;
        }

        const getTablesOptions = _=>{
            const options=(Object.keys(refData.current.tblInfo||{'no table':'no table'})).map(tblName=>{
                return {
                    text: tblName,
                    value: tblName
                };
            });
            return options;
        };
    
        const initConfig={
            title: `fld node settings`, // Dialog title
            initialData: { // Set initial values for all widgets
                tables: editor.refEditorData.current.tblName,
                fields: editor.refEditorData.current.fldName
            }, 
            body: {
                type: 'panel',
                items: [
                    {
                        type: 'listbox',
                        name: 'tables',
                        label: 'tables',
                        items: getTablesOptions()
                    },
                    {
                        type: 'listbox',
                        name: 'fields',
                        label: 'fields',
                        items: getFieldsOptions()
                        
                    },
                    {
                        type: 'listbox',
                        name: 'tags',
                        label: 'tags',
                        items: [
                            {
                                text: '',
                                value: ''
                            },
                            {
                                text: 'div',
                                value: 'div'
                            },
                            {
                                text: 'span',
                                value: 'span'
                            },
                            {
                                text: 'li',
                                value: 'li'
                            }
                        ]
                        
                    },
                    // {
                    //     type: 'input', // Input field for setting 1
                    //     name: 'setting1',
                    //     label: 'Setting 1'
                    // },
                    // {
                    //     type: 'input', // Input field for setting 2
                    //     name: 'setting2',
                    //     label: 'Setting 2'
                    // }
                ],
            },
            buttons: [
                {
                    type: 'cancel', // Cancel button
                    text: 'Cancel'
                },
                {
                    type: 'submit', // Submit button
                    text: 'Insert',
                    primary: true
                }
            ],
            onChange:(dialogApi, details) => {
                // console.log('onChange dialogApi, details:', dialogApi, details);
                switch(details.name){
                    case 'tables':
                        const tblName = dialogApi.getData()['tables'];
                        editor.refEditorData.current.tblName = tblName;
                        // [] Update the field list according to selected table using redial
                        getTblDef(tblName).then(tblDef=>{
                            editor.refEditorData.current.fldList = ([...Object.keys((tblDef||{}).inputSettings||{}),...Object.keys((tblDef||{}).embedInputs||{})]);
                            try{
                                dialogApi.redial({
                                    ...initConfig,
                                    initialData: { // Set initial values for all widgets
                                        tables: editor.refEditorData.current.tblName,
                                        fields: editor.refEditorData.current.fldName,
                                        tags: editor.refEditorData.current.tagName
                                    }, 
                                    body: {
                                        ...initConfig.body,
                                        items: [
                                            initConfig.body.items[0],
                                            {
                                                ...initConfig.body.items[1],
                                                items: getFieldsOptions()
                                            }
                                        ].concat(initConfig.body.items.slice(2))
                                    }
                                });
                            }catch(err){
                                console.log('[richtext redial error]', err);
                            }
                        })
                        break;
                    case 'fields':
                        const fldName = dialogApi.getData()['fields'];
                        editor.refEditorData.current.fldName = fldName;
                        break;
                    case 'tags':
                        const tagName = dialogApi.getData()['tags'];
                        editor.refEditorData.current.tagName = tagName;
                        break;
                }
            },
            onAction: (dialogApi, details) => {
                switch(details.name){
                    case 'tables':
                        console.log(dialogApi.getData());
                        break;

                }
            },
            onSubmit: function (dialogApi) {
                // Handle form submission
                const data = dialogApi.getData();

                const fldName = data['fields'];
                const tagName = data['tags'];

                // [] old way, insert node
                // const newNode = editor.dom.create('span', {
                //     // id: 'myDiv',
                //     // class: 'custom-class',
                //     "data-fldname": fldName,
                //     contenteditable: 'true',
                //     // style: 'color: red; border: 1px solid black; padding: 10px;'
                //     }, `[ ${fldName} ]`);
                // // [] insert new node
                // // editor.selection.setNode(newNode);
                // [] new way, add attribute to container
                const startNode = editor.selection.getStart();
                if (startNode) {
                    const parentNode = startNode.parentNode;
                    if(tagName){
                        const newNode = editor.dom.create(tagName, {
                            // id: 'myDiv',
                            // class: 'custom-class',
                            "data-fldname": fldName,
                            contenteditable: 'true',
                            // style: 'color: red; border: 1px solid black; padding: 10px;'
                            }, ``);
                        // [] insert new node
                        if(parentNode.getAttribute("data-fldname")){
                            // add as sibling
                            const parentParent = parentNode.parentNode;
                            parentParent.insertBefore(newNode, parentNode.nextSibling);
                        }else{
                            // add as sub
                            editor.selection.setNode(newNode);
                        }
                    }else{
                        parentNode.setAttribute("data-fldname", fldName);
                    }
                }

                editor.fire('change');

                // Close the dialog
                dialogApi.close();
            }
        };
        try{
            editor.windowManager.open(initConfig);            
        }catch(err){
            console.log('[richtext error]', err);
        }

    }

    useEffect(_=>{
        window.tinymce.PluginManager.add('mycustomplugin', function (editor, url) {
            // Add a button to the toolbar
            editor.ui.registry.addButton('mycustombutton', {
              text: 'My Plugin',
              onAction: function () {
                // Open the settings dialog when the button is clicked
                openAddFldSettingsDialog(editor);
              }
            });
        });
    }, []);

    // useLayoutEffect(_=>{
        // https://github.com/tinymce/tinymce/discussions/9207
        // https://cdnjs.com/libraries/tinymce
        // !editor&&window.hugerte.init({
        console.log('window.tinymce_script_url:', window.tinymce_script_url);
        setTimeout(_=>{
            !editor&&window.tinymce.init({
                selector: '#editor',
                inline: true,
                script_url : window.tinymce_script_url,
                fixed_toolbar_container: `#${refData.current.editorId}`,
                license_key: 'gpl',
                advcode_inline: true,
                // content_css: `${rootUrl}/bootstrap/bootstrap.css`,
                // `${rootUrl}/tinymce/css/custom-styles.css`,
                // content_css: window.tinymce_css_url,
                content_style: `
                    [data-fldname]:hover {
                        background: lightgray;
                    }

                    [data-fldname]::before {
                        content: attr(data-fldname);
                        display: inline-block;
                        background: #1e1e1e;
                        color: white;
                        padding: 8px 16px;
                        white-space: nowrap;
                        font-size: 14px;
                        border-radius: 4px;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                        pointer-events: none;
                    }
                `,

                // https://chat.deepseek.com/a/chat/s/0688449c-2c44-47a5-bee3-aeb5907c9475
                // [q] How could I make tinymce save customized property for tags?
                // []Validate and Sanitize Custom Attributes
                // valid_elements: '*[*]', // Allow all elements and attributes, suggested by deepseek
                // extended_valid_elements: 'p[data-custom]', // Specifically allow the custom attribute, suggested by deepseek

                height: "100%",
                menubar: false, // 是否显示菜单栏
                // contextmenu: false, // 是否显示右键菜单
                contextmenu: 'cut copy paste | customMenuItem | clearContainerMenuItem addBrMenuItem addFldMenuItem delFldMenuItem delFldWithTagMenuItem', // Extend the default menu
                // language: "zh-Hans", // 语言
                paste_data_images: true, // 是否粘贴图片
                remove_trailing_brs: true, // 删除尾部 br
                line_height_formats: "1 1.2 1.4 1.6 1.8 2.0", // 行高
                placeholder: "Ctrl + S 可保存邮件到草稿箱", // 占位符
                add_form_submit_trigger: true, // 添加表单提交触发器 ctrl+s
                toolbar_mode: "sliding", // 工具栏 更多按钮 的模式
                forced_root_block: "div", // 强制根节点为 div (回车符号, 间距过大问题)
                paste_webkit_styles: "all", // 保留所有 webkit 粘贴样式 eg: https://www.tiny.cloud/docs/tinymce/6/copy-and-paste/#paste_webkit_styles
                help_accessibility: true, // 帮助按钮是否可访问
                convert_urls: false, // TinyMCE 默认会将图片的 url 转换为相对路径, 这里禁用 (取得是 img 中 data-mce-src 的值)
                // images_upload_handler: handleUpload, // 图片上传
                // save_onsavecallback: handleSave, // 保存回调

                selector: `[taid="${refData.current.taId}"]`,
                    // plugins: [
                    // 'a11ychecker','advlist','advcode','advtable','autolink','checklist','export',
                    // 'lists','link','image','charmap','preview','anchor','searchreplace','visualblocks',
                    // 'powerpaste','fullscreen','formatpainter','insertdatetime','media','table','help','wordcount'
                    // ],
                    // toolbar: 'undo redo | a11ycheck casechange blocks | bold italic backcolor | alignleft aligncenter alignright alignjustify |' +
                    // 'bullist numlist checklist outdent indent | removeformat | code table help',
                    
                // plugins: 'link powerpaste casechange searchreplace autolink directionality advcode visualblocks visualchars image link media mediaembed codesample table charmap pagebreak nonbreaking anchor tableofcontents insertdatetime advlist lists checklist wordcount tinymcespellchecker editimage help formatpainter permanentpen charmap linkchecker emoticons advtable export autosave advcode fullscreen',
                // toolbar: 'code | undo redo print spellcheckdialog formatpainter | blocks fontfamily fontsize | bold italic underline forecolor backcolor | link image | alignleft aligncenter alignright alignjustify lineheight | checklist bullist numlist indent outdent | removeformat',
                
                
                plugins: [
                    "lists", // 列表 - bullist numlist
                    "advlist", // 高级列表 - bullist numlist
                    "charmap", // 字符映射表 - charmap
                    "code", // 代码 - code
                    "directionality", // 从左边/右边输入 - ltr rtl
                    "emoticons", // 表情符号 - emoticons
                    "fullscreen", // 全屏 - fullscreen
                    "help", // 帮助(一些快捷键和编辑器信息) - help
                    "image", // 图片 - image
                    "insertdatetime", // 插入日期时间 - insertdatetime
                    "link", // 链接 - link
                    "media", // 媒体 - media
                    "nonbreaking", // 不间断空格实体(&nbsp;) - nonbreaking
                    "pagebreak", // 分页符 - pagebreak
                    "preview", // 预览 - preview
                    "quickbars", // 快捷工具栏 - quickbars_selection_toolbar
                    "save", // 保存 - save
                    "table", // 表格 - table
                    "visualblocks", // 显示块级元素边框 - visualblocks
                    "visualchars", // 显示不可见字符 - visualchars
                    "wordcount", // 字数统计 - wordcount
                    // "translation", // 自定义插件
                    // "translationMenu", // 自定义插件
                    "mycustomplugin",
                    "advlist", "link", "lists"
                    // 'contextmenu'
                ],
                toolbar:
                //translation translationMenu |    
                "mycustombutton | undo redo removeformat | blocks fontfamily fontsize | bold italic underline |" +
                "forecolor backcolor | align lineheight | link emoticons table |" +
                "bullist numlist | preview fullscreen | outdent indent |" +
                "superscript subscript strikethrough blockquote charmap | ltr rtl |" +
                "visualchars visualblocks | hr nonbreaking pagebreak |" +
                "cut copy paste pastetext | code print insertdatetime |" +
                "image media wordcount help",
            
            
                height: opts.height||'20em',
                setup: (editor) => {
                    let toggleState = "";

                    // 注册自定义图标
                    editor.ui.registry.addIcon(
                        "translationIcon",
                        `<svg t="1709617096310" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4825" width="20" height="20">
                        <path d="M608 416h288c35.36 0 64 28.48 64 64v416c0 35.36-28.48 64-64 64H480c-35.36 0-64-28.48-64-64v-288H128c-35.36 0-64-28.48-64-64V128c0-35.36 28.48-64 64-64h416c35.36 0 64 28.48 64 64v288z m0 64v64c0 35.36-28.48 64-64 64h-64v256.032c0 17.664 14.304 31.968 31.968 31.968H864a31.968 31.968 0 0 0 31.968-31.968V512a31.968 31.968 0 0 0-31.968-31.968H608zM128 159.968V512c0 17.664 14.304 31.968 31.968 31.968H512a31.968 31.968 0 0 0 31.968-31.968V160A31.968 31.968 0 0 0 512.032 128H160A31.968 31.968 0 0 0 128 159.968z m64 244.288V243.36h112.736V176h46.752c6.4 0.928 9.632 1.824 9.632 2.752a10.56 10.56 0 0 1-1.376 4.128c-2.752 7.328-4.128 16.032-4.128 26.112v34.368h119.648v156.768h-50.88v-20.64h-68.768v118.272H306.112v-118.272H238.752v24.768H192z m46.72-122.368v60.48h67.392V281.92H238.752z m185.664 60.48V281.92h-68.768v60.48h68.768z m203.84 488H576L668.128 576h64.64l89.344 254.4h-54.976l-19.264-53.664h-100.384l-19.232 53.632z m33.024-96.256h72.864l-34.368-108.608h-1.376l-37.12 108.608zM896 320h-64a128 128 0 0 0-128-128V128a192 192 0 0 1 192 192zM128 704h64a128 128 0 0 0 128 128v64a192 192 0 0 1-192-192z" fill="#333333" p-id="4826"></path>
                        </svg>`
                    );
                
                    // 添加自定义按钮 - 单个按钮
                    editor.ui.registry.addMenuButton(
                        "translationMenu", 
                        {
                            // text: '翻译', // 按钮文字
                            icon: "translationIcon", // 按钮图标
                            tooltip: "翻译", // 按钮提示
                            fetch: (callback) => {
                            const items = [
                                {
                                type: "togglemenuitem", // ['menuitem' - 普通菜单, 'nestedmenuitem' - 嵌套菜单, 'togglemenuitem' - 切换菜单]
                                text: "zh",
                                onAction: () => {
                                    toggleState = "zh";
                                    editor.insertContent("你好！");
                                },
                                onSetup: (api) => {
                                    api.setActive("zh" == toggleState);
                                    return () => {};
                                },
                                },
                                {
                                type: "togglemenuitem",
                                text: "en",
                                onAction: () => {
                                    toggleState = "en";
                                    editor.insertContent("Hello!");
                                },
                                onSetup: (api) => {
                                    api.setActive("en" == toggleState);
                                    return () => {};
                                },
                                },
                            ];
                            callback(items);
                            },
                        }
                    );

                    // [start]
                    // Define the context toolbar
                    editor.ui.registry.addContextToolbar('customContextToolbar', {
                        // predicate: function (node) {
                        //     // Check if the cursor is inside content that matches the condition
                        //     const text = editor.selection.getContent({ format: 'text' });
                        //     return /__\w+__/.test(text); // Match text wrapped in double underscores
                        // },
                        predicate: function (node) {
                            // return node.tagName === 'SPAN' && node.innerText === 'special';
                            // return node.fldName;
                            return node.hasAttribute('data-fldname');
                        },
                        items: 'bold italic | deleteFld | deleteFldWithTag', // Toolbar items
                        position: 'node' // Position the toolbar relative to the selected node
                    });
                
                    // [add context buttons]
                    // [] 2 steps: 1. reg as below, 2. add item in addContextToolbar in previous codes addContextToolbar
                    // Add a custom button to the context toolbar
                    editor.ui.registry.addButton('deleteFld', {
                        text: 'del fld',
                        onAction: function (dialogApi, details) {
                            deleteFldAtCursor(editor);
                        }
                    });

                    // [] 2 steps: 1. reg as below, 2. add item in addContextToolbar in previous codes
                    editor.ui.registry.addButton('deleteFldWithTag', {
                        text: 'del fld and tag',
                        onAction: function (dialogApi, details) {
                            deleteFldAtCursorWithTag(editor);
                        }
                    });

                    // [end]

                    // [start right click dialog ]

                    // editor.on('click', function (e) {
                    //     const selectedText = editor.selection.getContent({ format: 'text' });
                    //     if (/__\w+__/.test(selectedText)) {
                    //       editor.windowManager.open({
                    //         title: 'Custom Menu',
                    //         body: {
                    //           type: 'panel',
                    //           items: [
                    //             {
                    //               type: 'button',
                    //               text: 'Custom Action 1',
                    //               onAction: function () {
                    //                 editor.notificationManager.open({
                    //                   text: 'You clicked Custom Action 1!',
                    //                   type: 'info'
                    //                 });
                    //               }
                    //             },
                    //             {
                    //               type: 'button',
                    //               text: 'Custom Action 2',
                    //               onAction: function () {
                    //                 editor.notificationManager.open({
                    //                   text: 'You clicked Custom Action 2!',
                    //                   type: 'info'
                    //                 });
                    //               }
                    //             }
                    //           ]
                    //         },
                    //         buttons: [
                    //           {
                    //             type: 'cancel',
                    //             text: 'Close'
                    //           }
                    //         ]
                    //       });
                    //     }
                    //   });


                    // [end]


                    // [start right click menu]

                    // editor.ui.registry.addMenuItem('customMenuItem', {
                    //     text: 'Custom Action',
                    //     onAction: function () {
                    //       // Perform an action when the menu item is clicked
                    //       const selectedNode = editor.selection.getNode();
                    //       editor.dom.setStyle(selectedNode, 'color', 'red');
                
                    //       // Notify the user
                    //       editor.notificationManager.open({
                    //         text: 'Custom action applied!',
                    //         type: 'info'
                    //       });
                    //     }
                    //   });

                    // [add right click menu items]
                    // [] 2 steps: 1. reg as below, 2. add item in addContextToolbar in init's contextmenu key

                    // Add a custom context menu
                    // editor.ui.registry.addContextMenu('addFldContextMenu', {
                    //     update: function (element) {
                    //         // Show the menu only if the selected element meets a condition
                    //         // return element.tagName === 'P'; // Example: Show only for <p> elements
                    //         return true;
                    //     },
                    //     items: 'addFldMenuItem' // Add a custom menu item
                    // });

                    // add fld
                    editor.ui.registry.addMenuItem(
                        'addFldMenuItem', 
                        {
                            text: 'add fld',
                            onAction: function () {
                                // // Perform an action when the menu item is clicked
                                // const selectedNode = editor.selection.getNode();
                                // editor.dom.setStyle(selectedNode, 'color', 'red');

                                // // Notify the user
                                // editor.notificationManager.open({
                                //     text: 'Custom action applied!',
                                //     type: 'info'
                                // });
                                openAddFldSettingsDialog(editor);
                            }
                        }
                    );

                    editor.ui.registry.addMenuItem(
                        'delFldWithTagMenuItem', 
                        {
                            text: 'del fld with tag',
                            onAction: function () {
                                deleteFldAtCursorWithTag(editor);
                            },
                            onSetup: function (api) {
                                // const node = editor.selection.getNode();
                                // // Only show the menu item if the cursor is inside a <p> element
                                // api.setDisabled(node.tagName !== 'P');
                                // return function () {}; // No cleanup needed

                                // get current node
                                const node = editor.selection.getNode();

                                // get target node
                                const selector = `[data-fldname]`;
                                const tgtNode = editor.dom.is(node, selector)?node:editor.dom.getParent(node, selector);

                                api.setEnabled(!!tgtNode);

                                return function () {}; // No cleanup needed

                            }
                        }
                    );

                    editor.ui.registry.addMenuItem(
                        'delFldMenuItem', 
                        {
                            text: 'del fld',
                            onAction: function () {
                                // // Perform an action when the menu item is clicked
                                // const selectedNode = editor.selection.getNode();
                                // editor.dom.setStyle(selectedNode, 'color', 'red');

                                // // Notify the user
                                // editor.notificationManager.open({
                                //     text: 'Custom action applied!',
                                //     type: 'info'
                                // });
                                deleteFldAtCursor(editor);
                            },
                            onSetup: function (api) {
                                // const node = editor.selection.getNode();
                                // // Only show the menu item if the cursor is inside a <p> element
                                // api.setDisabled(node.tagName !== 'P');
                                // return function () {}; // No cleanup needed

                                // get current node
                                const node = editor.selection.getNode();

                                // get target node
                                const selector = `[data-fldname]`;
                                const tgtNode = editor.dom.is(node, selector)?node:editor.dom.getParent(node, selector);

                                api.setEnabled(!!tgtNode);

                                return function () {}; // No cleanup needed

                            }
                        }
                    );
                    
                    editor.ui.registry.addMenuItem(
                        'clearContainerMenuItem', 
                        {
                            text: 'clear container',
                            onAction: function () {
                                clearContainer(editor);
                            },
                            onSetup: function (api) {
                            }
                        }
                    );

                    editor.ui.registry.addMenuItem(
                        'addBrMenuItem', 
                        {
                            text: 'add br',
                            onAction: function () {
                                addBr(editor);
                            },
                            onSetup: function (api) {
                            }
                        }
                    );
                    // editor.ui.registry.addContextMenu('delFldContextMenu', {
                    //     update: function (element) {
                    //         // Show the menu only if the selected element meets a condition
                    //         // return element.tagName === 'P'; // Example: Show only for <p> elements

                    //         // get current node
                    //         const node = editor.selection.getNode();

                    //         // get target node
                    //         const selector = `[data-fldname]`;
                    //         const tgtNode = editor.dom.is(node, selector)?node:editor.dom.getParent(node, selector);

                    //         return tgtNode;
                    //     },
                    //     items: 'addFldMenuItem' // Add a custom menu item
                    // });
                    // [end]


                    // // [start] Add a custom menu item for delete fld tag
                    // editor.ui.registry.addMenuItem('delfldtag', {
                    //     text: 'Custom Action',
                    //     onAction: function () {
                    //     // Perform an action when the menu item is clicked
                    //     const selectedNode = editor.selection.getNode();
                    //     editor.dom.setStyle(selectedNode, 'color', 'red');

                    //     // Notify the user
                    //     editor.notificationManager.open({
                    //         text: 'Custom action applied!',
                    //         type: 'info'
                    //     });
                    //     },
                    //     // Conditionally show the menu item
                    //     onSetup: function (api) {
                    //     const node = editor.selection.getNode();
                    //     // Only show the menu item if the cursor is inside a <p> element
                    //     api.setDisabled(node.tagName !== 'P');
                    //     return function () {}; // No cleanup needed
                    //     }
                    // });
                    // //   [end]

                    // ---------------

                    editor.on('init', () => {
                        // editor.setContent('<div><h1>Setting the editor content with JavaScript</h1><p>This content replaces the placeholder.</p></div>');
                        editor.setContent(form.getValues()[fldName]);
                        editor.on('init', function () {
                            // Add custom attributes to specific tags
                            editor.dom.setAttrib('div', 'fldName', 'fldName');
                        });
                    
                    
                    });

                    editor.on('change', () => {
                        const content = editor.getContent({ format: 'html' });
                        // console.log('content:', content);
                        form.setValue(fldName, content);
                    });
                },

                ui_container: '.modal',
                // https://www.tiny.cloud/docs/tinymce/latest/ui-mode-configuration-options/
                // [] this makes toolbar popups follow the editor when scroll
                ui_mode: 'split',

                inline: false
            }).then(r=>{
                const _editor = r[0];
                if(_editor){
                    _editor.refEditorData = refEditorData;
                    setEditor(_editor);
                }
            });

        }, 100)
    // }, []);

    if (isLoading()) {
        return <div>Loading...</div>;
    }

    if (hasError()) {
        return <div>Error: {getErrMsgs().map(((errMsg, errMsgIdx)=><h3 key={`${errMsgIdx}`}>{errMsg}</h3>))}</div>;
    }

    refData.current.tblInfo = tblInfo;
    return <>
        <div id={refData.current.editorId} />
        <textarea
            taid={refData.current.taId}
            {...rest}
        />
        {form.formState.errors[fldName] && <p className="fld-error">{form.formState.errors[fldName].message}</p>}
    </>;
}